import CrossIcon from "../../assets/svg/CrossIcon.svg";
import { Button } from "../ui/button";
import { useFormik } from "formik";
import kanaban from "../../assets/svg/kanBanNew.svg";
import gantt from "../../assets/svg/ganttNew.svg";
import calendar from "../../assets/svg/CalenderNewIcon.svg";
import list from "../../assets/svg/listNew.svg";
// import InfoCircle from "../../assets/svg/Info circle.svg";
import { useEffect, useState } from "react";
import { toFormikValidationSchema } from "zod-formik-adapter";
import {
  createPortfolioAndProgramSchema,
  createProjectSchema,
  updateProjectSchema,
} from "@backend/src/schemas/projectSchema";
import { z } from "zod";
import useProjectMutation from "@/api/mutation/useProjectMutation";
import { isAxiosError } from "axios";
import useProjectQuery, { Project } from "@/api/query/useProjectQuery";
import useProjectUpdateMutation from "@/api/mutation/useProjectUpdateMutation";
// import {
//   TooltipProvider,
//   Tooltip,
//   TooltipTrigger,
//   TooltipContent,
// } from "../ui/tooltip";
import { toast } from "react-toastify";
import countries from "../../assets/json/countries.json";
import Select, { SingleValue } from "react-select";
import ErrorMessage from "../common/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { ProjectDefaultViewEnumValue } from "@backend/src/schemas/enums";
import { errorConfig } from "@/lib/toastError";
import InputText from "../common/InputText";
import { InputRadio } from "../common/InputRadio";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useAllPortfoliosQuery, {
  Portfolios,
  Program,
} from "@/api/query/useAllPortFoliosQuery";
import NewPlus from "@/assets/svg/NewPlus.svg";
import Dialog from "../common/Dialog";
import useCreatePortfolioProgramMutation from "@/api/mutation/useCreatePortfolioProgram";
import TrashCan from "@/assets/svg/TrashCan.svg";
import Loader from "../common/Loader";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";

type Options = { label: string | JSX.Element; value: string };

type AddProjectType = {
  handleClosePopUp: () => void;
  editData?: Project;
};
const reactSelectStyleWorkingDays = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    paddingLeft: "0.2rem",
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
} as const;
function CreateUpdateProjectForm(props: AddProjectType) {
  const { t } = useTranslation();
  const { handleClosePopUp, editData } = props;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const errorStyle = "text-red-400 block text-sm h-1";
  const labelStyle = "font-medium text-sm text-[#787486]/30 ";
  const projectMutation = useProjectMutation();
  const projectUpdateMutation = useProjectUpdateMutation(
    editData ? editData.projectId : ""
  );
  const allPortfoliosQuery = useAllPortfoliosQuery();
  const [currencyValue, setCurrencyValue] = useState<SingleValue<Options>>();
  const RADIO_BUTTON_OPTIONS = [
    {
      id: 4,
      title: "list",
      description: t("list_description"),
      img: list,
    },
    {
      id: 2,
      title: "gantt",
      description: t("gantt_description"),
      img: gantt,
    },
    {
      id: 1,
      title: "kanban",
      description: t("kanban_description"),
      img: kanaban,
    },
    {
      id: 3,
      title: "calendar",
      description: t("calendar_description"),
      img: calendar,
    },
  ];

  const [allPortfolios, setAllPortfolios] = useState<{
    programs: Program[];
    portfolios: Portfolios[];
  }>();
  const [portfolios, setPortfolios] = useState<Options[]>([]);
  const [programs, setPrograms] = useState<Options[]>([]);
  const [createPortfolio, setCreatePortfolio] = useState<
    "portfolio" | "program"
  >();
  const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
    portfolio: string;
    program: string;
  }>();

  const createPortfolioAndProgramFormik = useFormik({
    initialValues: { program: "", portfolio: "" },
    validationSchema: toFormikValidationSchema(createPortfolioAndProgramSchema),
    onSubmit(values) {
      createPortfolioAndProgram(values);
    },
  });
  const projectQuery = useProjectQuery(false);
  const navigate = useNavigate();
  const formik = useFormik<z.infer<typeof createProjectSchema>>({
    initialValues: {
      projectName: "",
      projectDescription: "",
      startDate: "" as unknown as Date,
      estimatedEndDate: "" as unknown as Date,
      estimatedBudget: "",
      defaultView: ProjectDefaultViewEnumValue.GANTT,
      currency: "USD",
      portfolio: "",
      program: "",
      isMilestone:false,
    },
    validationSchema:
      editData && editData.projectId
        ? toFormikValidationSchema(updateProjectSchema)
        : toFormikValidationSchema(createProjectSchema),
    onSubmit: (values, helper) => {
      if (editData && editData.projectId) {
        if (!values.estimatedEndDate) {
          delete values.estimatedEndDate;
        }
        projectUpdateMutation.mutate(values, {
          onSuccess(data) {
            projectQuery.refetch();
            formik.resetForm();
            navigate("/projects/");
            handleClosePopUp();
            setIsSubmitting(false);
            toast.success(data.data.message);
          },
          onError(error) {
            setIsSubmitting(false);
            if (isAxiosError(error)) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        });
      } else {
        if (!values.estimatedEndDate) {
          delete values.estimatedEndDate;
        }
        projectMutation.mutate(values, {
          onSuccess(data) {
            projectQuery.refetch();
            formik.resetForm();
            navigate(`/tasks/${data.data.data.projectId}`);
            handleClosePopUp();
            toast.success(data.data.message);
          },
          onError(error) {
            setIsSubmitting(false);
            if (isAxiosError(error)) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.forEach((item) => {
                  helper.setFieldError(item.path[0], item.message);
                });
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        });
      }
    },
  });

  useEffect(() => {
    const data = allPortfoliosQuery.data?.data.data;
    setAllPortfolios(data);
    setPortfolios([
      { label: t("Select portfolio"), value: "" },
      ...(data?.portfolios ?? []).map(({ portfolioId, portfolioName }) => ({
        value: portfolioId,
        label: (
          <div className={`flex gap-2 justify-between items-center`}>
            {portfolioName}
            <span
              className={`font-bold text-xs text-red-400 ${
                formik.values.portfolio == portfolioId ? "hidden" : ""
              }`}
              onClick={() => {
                setDeletePortfolioAndProgram({
                  portfolio: portfolioId,
                  program: "",
                });
              }}
            >
              ✖
            </span>
          </div>
        ),
      })),
    ]);
  }, [allPortfoliosQuery.data?.data.data, formik.values.portfolio]);
  useEffect(() => {
    const selectedPortfolio = allPortfolios?.portfolios.find(
      ({ portfolioId }) => portfolioId === formik.values.portfolio
    );
    if (selectedPortfolio) {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(selectedPortfolio?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: (
            <div className="flex gap-2 justify-between items-center">
              {programName}
              <span
                className={`font-bold text-xs text-red-400 ${
                  formik.values.program == programId ? "hidden" : ""
                } `}
                onClick={() => {
                  setDeletePortfolioAndProgram({
                    portfolio: "",
                    program: programId,
                  });
                }}
              >
                ✖
              </span>
            </div>
          ),
        })) ?? []),
      ]);
    } else {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(allPortfolios?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: (
            <div className="flex gap-2 justify-between items-center">
              {programName}
              <span
                className={`font-bold text-xs text-red-400 ${
                  formik.values.program == programId ? "hidden" : ""
                } `}
                onClick={() => {
                  setDeletePortfolioAndProgram({
                    portfolio: "",
                    program: programId,
                  });
                }}
              >
                ✖
              </span>
            </div>
          ),
        })) ?? []),
      ]);
    }
  }, [
    allPortfolios?.portfolios,
    allPortfolios?.programs,
    formik.values.portfolio,
    formik.values.program,
    t,
  ]);
  useEffect(() => {
    if (editData) {
      const formatDate = (inputDate: string) => {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        return `${year}-${month.toString().padStart(2, "0")}-${day
          .toString()
          .padStart(2, "0")}`;
      };
      formik.setValues({
        startDate: formatDate(editData.startDate) as unknown as Date,
        estimatedEndDate: formatDate(
          editData.estimatedEndDate
        ) as unknown as Date,
        estimatedBudget: editData.estimatedBudget,
        projectDescription: editData.projectDescription,
        projectName: editData.projectName,
        defaultView: editData.defaultView,
        currency: editData.currency,
      });
      setCurrencyValue({ label: editData.currency, value: editData.currency });
    }
  }, []);

  const currencyFn = () => {
    const value = countries.map((item) => {
      return { label: item.currency, value: item.currency };
    });

    const seenValues = new Set();
    const uniqueArray = value
      .filter((item) => {
        if (seenValues.has(item.value)) {
          return false;
        }
        seenValues.add(item.value);
        return true;
      })
      .sort((a, b) => {
        return a.value.localeCompare(b.value);
      });

    return uniqueArray;
  };

  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "1px solid #E7E7E7",
      paddingTop: "0.2rem",
      paddingBottom: "0.2rem",
      zIndex: 1000,
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: state.isFocused ? "1px solid #299d91" : "1px solid #E7E7E7",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };

  const handleCurrency = (val: SingleValue<Options>) => {
    if (val) {
      setCurrencyValue(val);
      formik.setFieldValue("currency", val.value);
    }
  };

  const createPortfolioProgramMutation = useCreatePortfolioProgramMutation();
  const createPortfolioAndProgram = (
    value: z.infer<typeof createPortfolioAndProgramSchema>
  ) => {
    createPortfolioProgramMutation.mutate(value, {
      onSuccess() {
        allPortfoliosQuery.refetch().then((res) => {
          const findPortfolio = res.data?.data.data.portfolios.find(
            (p) => p.portfolioName == value.portfolio
          );
          const findNewProgram = findPortfolio?.programs.find(
            (t) => t.programName == value.program
          );
          formik.setFieldValue("program", findNewProgram?.programId);
          formik.setFieldValue("portfolio", findPortfolio?.portfolioId);
        });
        setCreatePortfolio(undefined);
        createPortfolioAndProgramFormik.resetForm();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message ?? ""),
          errorConfig
        );
      },
    });
  };
  const removeProgramMutation = useRemoveProgramMutation();
  const removePortfolioMutation = useRemovePortfolioMutation();
  const handleRemovePortfolioAndProgram = () => {
    if (deletePortfolioAndProgram?.portfolio) {
      removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
        onSuccess() {
          allPortfoliosQuery.refetch().then(() => {
            formik.setFieldValue("portfolio", "");
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
    if (deletePortfolioAndProgram?.program) {
      removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
        onSuccess() {
          allPortfoliosQuery.refetch().then(() => {
            formik.setFieldValue("program", "");
            setDeletePortfolioAndProgram(undefined);
            projectQuery.refetch();
          });
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    }
  };

  return (
    <div className="fixed bg-[#00000066] w-full top-0 left-0 h-full items-center flex justify-center z-50">
      {(allPortfoliosQuery.isFetching || allPortfoliosQuery.isRefetching) && (
        <Loader className="absolute top-0 left-0 bg-white z-[60]" />
      )}
      <div className="lg:rounded-lg border p-5 border-white bg-[#fff] md:max-w-5xl w-full flex flex-col h-auto pb-8  max-h-screen overflow-y-auto ">
        <div className="flex justify-between py-5 px-4 border-b border-gray-100 lg:border-none">
          <div className="text-2xl lg:text-4xl font-bold text-gray-500 ">
            {t("create_new_project")}
          </div>
          <div
            onClick={handleClosePopUp}
            className="flex items-center justify-center cursor-pointer"
          >
            <img src={CrossIcon}></img>
          </div>
        </div>
        <div className="px-5 overflow-y-auto max-h-screen overflow-auto">
          <div className="lg:flex rounded-lg lg:justfy-center w-full">
            <form onSubmit={formik.handleSubmit} className="w-full">
              <div className="w-full lg:flex justify-around lg:gap-8">
                <div className="flex gap-2 flex-col lg:w-[50%]">
                  <div className="text-left">
                    <div className="flex justify-between items-center">
                      <label className={`${labelStyle}`}>
                        {" "}
                        {t("name")}
                        <span className="ml-0.5 text-red-500">*</span>
                      </label>
                      {/* <div className="flex gap-2 items-center">
                        <input
                          type="checkbox"
                          checked={formik.values.isMilestone}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "isMilestone",
                              e.target.checked
                            );
                          }}
                        />
                        <label className={`${labelStyle}`}>
                          {t("milestone")}
                        </label>
                      </div> */}
                    </div>
                    <InputText
                      name="projectName"
                      placeholder="Project one"
                      value={formik.values.projectName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="mt-0"
                    />
                    <span className={errorStyle}>
                      {formik.touched.projectName &&
                        formik.errors.projectName &&
                        t(formik.errors.projectName)}
                    </span>
                  </div>
                  <div className="flex gap-2 items-center w-full">
                    <div className="w-full">
                      <div className="flex gap-2 justify-between items-center">
                        <label className={labelStyle}>{t("Portfolio")}</label>
                        <Button
                          className="p-0 h-fit"
                          type="button"
                          variant={"none"}
                          onClick={() => setCreatePortfolio("portfolio")}
                        >
                          <img
                            src={NewPlus}
                            alt=""
                            className="min-w-4 w-4 invert"
                          />
                        </Button>
                      </div>
                      <Select
                        key={formik.values.portfolio}
                        className="mt-2"
                        placeholder="Select Portfolio"
                        options={portfolios}
                        value={portfolios.find(
                          (option) =>
                            option.value === (formik.values.portfolio ?? "")
                        )}
                        styles={{
                          ...reactSelectStyleWorkingDays,
                        }}
                        onChange={(e) => {
                          const val = e as Options;
                          if (val && val.value) {
                            formik.setFieldValue("portfolio", val.value);
                            const label =
                              allPortfoliosQuery.data?.data.data.portfolios.find(
                                (t) => t.portfolioId == val.value
                              );
                            createPortfolioAndProgramFormik.setFieldValue(
                              "portfolio",
                              label?.portfolioName
                            );
                          } else {
                            formik.setFieldValue("portfolio", "");
                            createPortfolioAndProgramFormik.setFieldValue(
                              "portfolio",
                              ""
                            );
                          }
                          formik.setFieldValue("program", "");
                        }}
                      ></Select>
                    </div>
                    <div className="w-full">
                      <div className="flex gap-2 justify-between items-center">
                        <label className={labelStyle}>{t("Program")}</label>
                        <Button
                          className="p-0 h-fit"
                          type="button"
                          variant={"none"}
                          onClick={() => {
                            setCreatePortfolio("program");
                            const label =
                              allPortfoliosQuery.data?.data.data.portfolios.find(
                                (t) => t.portfolioId == formik.values.portfolio
                              );
                            createPortfolioAndProgramFormik.setFieldValue(
                              "portfolio",
                              label?.portfolioName
                            );
                          }}
                        >
                          <img
                            src={NewPlus}
                            alt=""
                            className="min-w-4 w-4 invert"
                          />
                        </Button>
                      </div>
                      <Select
                        key={`${formik.values.portfolio}${formik.values.program}`}
                        className="mt-2"
                        placeholder="Select Program"
                        options={programs}
                        styles={{
                          ...reactSelectStyleWorkingDays,
                        }}
                        value={programs.find(
                          (option) =>
                            option.value === (formik.values.program ?? "")
                        )}
                        onChange={(e) => {
                          const val = e as Options;
                          if (val && val.value) {
                            formik.setFieldValue("program", val.value);
                          } else {
                            formik.setFieldValue("program", "");
                          }
                        }}
                      ></Select>
                    </div>
                  </div>
                  <div className="text-left">
                    <label className={labelStyle}>{t("Description")}</label>
                    <textarea
                      rows={5}
                      cols={30}
                      name="projectDescription"
                      placeholder="Description"
                      className="py-1.5 px-3 rounded-md border border-gray-100 mt-0 w-full"
                      value={formik.values.projectDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <span className={errorStyle}>
                      {formik.touched.projectDescription &&
                        t(formik.errors.projectDescription as string)}
                    </span>
                  </div>

                  <div className="sm:flex sm:gap-[10px] w-full">
                    <div className="text-left sm:w-1/2">
                      <label className={labelStyle}>
                        {t("start_date")}
                        <span className="ml-0.5 text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        name="startDate"
                        className="py-1.5 px-3 rounded-lg border border-gray-100 mt-0 w-full h-[46px] focus:outline-primary-400"
                        value={formik.values.startDate as unknown as string}
                        placeholder="Placeholder"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span className={errorStyle}>
                        {formik.touched.startDate &&
                          (formik.errors.startDate as string)}
                      </span>
                    </div>
                    <div className="text-left sm:w-1/2">
                      <label className={labelStyle + "flex gap-1"}>
                        {t("estimated_end_date")}
                        {/* <span className="ml-0.5 text-red-500">*</span> */}
                        <div className="flex items-center justify-center relative">
                          {/* <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px]"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p> Date will be automatically </p>
                                <p>updated after saving a baseline</p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider> */}
                        </div>
                      </label>
                      <input
                        type="date"
                        name="estimatedEndDate"
                        className="py-1.5 px-3 rounded-lg border border-gray-100 mt-0 w-full h-[46px] focus:outline-primary-400"
                        placeholder="Placeholder"
                        value={
                          (formik.values
                            .estimatedEndDate as unknown as string) ?? ""
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span className={errorStyle}>
                        {formik.touched.estimatedEndDate &&
                          (formik.errors.estimatedEndDate as string)}
                      </span>
                    </div>
                  </div>
                  <div className="text-left flex gap-2 ">
                    <div className="w-36">
                      <label className={labelStyle}>{t("currency")}</label>
                      <Select
                        className="z-0"
                        onChange={handleCurrency}
                        onBlur={() => formik.setTouched({ currency: true })}
                        options={currencyFn()}
                        value={currencyValue}
                        defaultValue={{ label: "USD", value: "USD" }}
                        placeholder="Currency"
                        name="currency"
                        menuPlacement="auto"
                        styles={reactSelectStyle}
                      />
                      <ErrorMessage>
                        {formik.touched.currency && formik.errors.currency}
                      </ErrorMessage>
                    </div>
                    <div className=" w-full">
                      <label className={labelStyle}>
                        {t("estimated_budget")}
                        {/* <span className="ml-0.5 text-red-500">*</span> */}
                      </label>
                      <InputText
                        name="estimatedBudget"
                        placeholder="Estimated budget"
                        className={"mt-0"}
                        value={formik.values.estimatedBudget ?? ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <span className={errorStyle}>
                        {formik.touched.estimatedBudget &&
                          formik.errors.estimatedBudget}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="lg:w-[50%]">
                  <div className="text-xl font-normal text-gray-450 mt-4 lg:mt-0">
                    {t("default_view")}
                  </div>
                  <div className="flex flex-col gap-2 ">
                    {RADIO_BUTTON_OPTIONS.map((radioButton) => (
                      <div
                        key={radioButton.id}
                        className={`h-full w-full rounded-lg border ${
                          formik.values.defaultView ===
                          radioButton.title.toUpperCase()
                            ? "  outline-emerald-700 bg-primary-500 "
                            : " border-gray-100"
                        }`}
                      >
                        <label className="flex lg:gap-3.5 gap-4 px-5 py-2.5 items-center h-full cursor-pointer">
                          <InputRadio
                            name="defaultView"
                            value={radioButton.title.toUpperCase()}
                            checked={
                              formik.values.defaultView ===
                              radioButton.title.toUpperCase()
                            }
                            onChange={formik.handleChange}
                            className="hidden"
                          />
                          <div
                            className={`h-12 flex  border rounded-md bg-gray-450 ${
                              formik.values.defaultView ===
                                radioButton.title.toUpperCase() &&
                              "brightness-0 invert bg-transparent"
                            }`}
                          >
                            <img
                              src={radioButton.img}
                              className={`h-full w-full brightness-0 invert p-2 `}
                              alt={`${radioButton.title} ${t("view")}`}
                            />
                          </div>
                          <div className="flex flex-col lg:gap-1.5 gap-0.5">
                            <div
                              className={`font-semibold text-gray-600 text-xl ${
                                formik.values.defaultView ===
                                  radioButton.title.toUpperCase() &&
                                "text-white"
                              }`}
                            >
                              {t(radioButton.title)}
                            </div>
                            <div
                              className={`font-noraml text-gray-500 text-xs ${
                                formik.values.defaultView ===
                                  radioButton.title.toUpperCase() &&
                                "text-white"
                              }`}
                            >
                              {radioButton.description}
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="flex justify-end mt-6 lg:mt-2">
                <Button
                  type="submit"
                  variant={"primary"}
                  className="font-medium text-lg px-9"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                >
                  {t("save")}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Dialog
        isOpen={Boolean(createPortfolio)}
        onClose={() => setCreatePortfolio(undefined)}
        modalClass="rounded-md p-6 w-96 max-h-full h-auto"
      >
        <div className="">
          <div className="flex gap-2 justify-between items-center mb-2">
            <h2 className="text-gray-800">
              {createPortfolio == "portfolio"
                ? t("Create Portfolio")
                : t("Create Program")}
            </h2>
            <div>
              <img
                src={CrossIcon}
                className="w-3 min-w-3 cursor-pointer"
                onClick={() => {
                  setCreatePortfolio(undefined);
                }}
              />
            </div>
          </div>
          {createPortfolio == "portfolio" && (
            <div>
              <label className={labelStyle + " !mt-2"}>{t("Portfolio")}</label>
              <InputText
                onChange={createPortfolioAndProgramFormik.handleChange}
                onBlur={createPortfolioAndProgramFormik.handleBlur}
                name="portfolio"
                className="mt-0"
              />
              {createPortfolioAndProgramFormik.touched.portfolio &&
                createPortfolioAndProgramFormik.errors.portfolio && (
                  <ErrorMessage>
                    {createPortfolioAndProgramFormik.errors.portfolio}
                  </ErrorMessage>
                )}
            </div>
          )}
          {createPortfolio == "program" && (
            <div>
              <div>
                <div className="flex gap-2 justify-between items-center">
                  <label className={labelStyle}>{t("Portfolio")}</label>
                </div>
                <Select
                  key={createPortfolioAndProgramFormik.values.portfolio}
                  className="mt-2"
                  placeholder="Select Portfolio"
                  options={portfolios}
                  isDisabled={Boolean(formik.values.portfolio)}
                  value={portfolios.find((option) => {
                    const portfolio =
                      allPortfoliosQuery.data?.data.data.portfolios.find(
                        (t) =>
                          t.portfolioName ==
                          createPortfolioAndProgramFormik.values.portfolio
                      );
                    if (option.value == portfolio?.portfolioId) {
                      return option;
                    }
                  })}
                  styles={{
                    ...reactSelectStyleWorkingDays,
                  }}
                  onChange={(e) => {
                    const val = e as Options;
                    if (val && val.value) {
                      const findPort = allPortfolios?.portfolios.find(
                        (e) => e.portfolioId == val.value
                      );
                      createPortfolioAndProgramFormik.setFieldValue(
                        "portfolio",
                        findPort?.portfolioName
                      );
                    } else {
                      createPortfolioAndProgramFormik.setFieldValue(
                        "portfolio",
                        ""
                      );
                    }
                  }}
                ></Select>
              </div>
              <div>
                <label className={labelStyle + " !mt-2"}>{t("Program")}</label>
                <InputText
                  onChange={createPortfolioAndProgramFormik.handleChange}
                  onBlur={createPortfolioAndProgramFormik.handleBlur}
                  name="program"
                  className="mt-0 z-50"
                />
                {createPortfolioAndProgramFormik.touched.program &&
                  createPortfolioAndProgramFormik.errors.program && (
                    <ErrorMessage>
                      {createPortfolioAndProgramFormik.errors.program}
                    </ErrorMessage>
                  )}
              </div>
            </div>
          )}
          <div className="flex gap-2 items-center justify-end w-full mt-2">
            <Button
              type="button"
              variant={"destructive"}
              onClick={() => {
                setCreatePortfolio(undefined);
              }}
              isLoading={createPortfolioProgramMutation.isPending}
            >
              {t("cancel")}
            </Button>
            <Button
              type="button"
              variant={"primary"}
              onClick={() => {
                createPortfolioAndProgramFormik.submitForm();
              }}
              isLoading={createPortfolioProgramMutation.isPending}
            >
              {t("submit")}
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        isOpen={Boolean(
          deletePortfolioAndProgram?.portfolio ||
            deletePortfolioAndProgram?.program
        )}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 text-center ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {deletePortfolioAndProgram?.portfolio
            ? t("remove_portfolio")
            : t("remove_program")}
          <span className="text-xs text-gray-600">
            (
            {t("remove_portfolio_and_project_description", {
              project: deletePortfolioAndProgram?.portfolio
                ? `${t("program")} ${t("and")} ${t("project")}`
                : `${t("project")}`,
            })}
            )
          </span>
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              onClick={() => setDeletePortfolioAndProgram(undefined)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              // isLoading={removeTaskMutation.isPending}
              // disabled={removeTaskMutation.isPending}
              onClick={handleRemovePortfolioAndProgram}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default CreateUpdateProjectForm;
